export enum ReferrerPayoutStatus {
  Pending = "pending",
  Paid = "paid",
  Failed = "failed",
}
